import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { ProviderType, ProviderPlatformType, ProviderStatusType } from '@/types/provider';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ProviderState = {
  data: ProviderType[];
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
  dataPlatform: ProviderPlatformType[];
  dataStatus: ProviderStatusType[];
  dataDetailsProvider?: ProviderType;
};

export const providerInitialState: ProviderState = {
  data: [],
  dataPlatform: [],
  dataStatus: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
  dataDetailsProvider: undefined,
};

const slice = createSlice({
  name: 'provider',
  initialState: providerInitialState,
  reducers: {
    setListProviderAction(
      state,
      action: PayloadAction<{
        data: ProviderType[];
        pagination?: PaginationAPI;
        totalExtend?: number;
        append?: boolean;
      }>,
    ) {
      const { payload } = action;
      
      if (payload.append) {
        // Append new data to existing data
        state.data = [...state.data, ...payload.data];
      } else {
        // Replace existing data
        state.data = payload.data;
      }

      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },
    setProviderLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setProviderPlatformAction(
      state,
      { payload }: PayloadAction<{ dataPlatform: ProviderPlatformType[] }>,
    ) {
      state.dataPlatform = payload.dataPlatform;
    },
    setProviderStatusAction(
      state,
      { payload }: PayloadAction<{ dataStatus: ProviderStatusType[] }>,
    ) {
      state.dataStatus = payload.dataStatus;
    },
    setDetailsProviderAction(state, { payload }: PayloadAction<ProviderType>) {
      state.dataDetailsProvider = payload;
    },
    addProviderAction(state, { payload }: PayloadAction<ProviderType>) {
      state.data = [payload, ...state.data];
      state.pagination = {
        ...state.pagination,
        Page: state.pagination.Page + 1,
        totalElements: state.pagination.totalElements + 1,
      };
    },
    updateProviderAction(state, { payload }: PayloadAction<ProviderType>) {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    }
  },
});

export const {
  setListProviderAction,
  setProviderLoading,
  setProviderPlatformAction,
  setProviderStatusAction,
  setDetailsProviderAction,
  addProviderAction,
  updateProviderAction,
} = slice.actions;
export default slice.reducer;
